import { takeEvery, put } from 'redux-saga/effects';
import { FETCH_POPUP_DATA } from './ActionTypes';
import { select } from 'redux-saga/effects';
import { getService, getAxiosHeaders } from "../../../library/RestAPI";
import { 
  getFinalURL,
  SET_POPUP_DATA,
  SET_POPUP_OPEN,
  SET_POPUP_LOADER,
  OPEN_DETAILS_POPUP,
 } from './ActionTypes';
function* fetchPopupData(action) {
  try {
    yield put({ type: SET_POPUP_LOADER, payload: true });
    const popupOpen = yield select((state) => state.DataguardReducer.popupOpen);
    const popupDetails = yield select((state) => state.DataguardReducer.popupDetails);
    const fromTimeStamp = yield select((state) => state.DataguardReducer.fromTimeStamp);
    const toTimeStamp = yield select((state) => state.DataguardReducer.toTimeStamp);
    const page = action.payload?.page || 0;
    const pageSize = action.payload?.pageSize || 10;
    if (!popupOpen || !popupDetails) return; // Only fetch if popup is open
    const apiEndpoint = getFinalURL(popupDetails.hierarchy, { ...popupDetails, fromTimeStamp, toTimeStamp, page, pageSize });
    let options = {
      method: "GET",
      url: apiEndpoint,
      headers: getAxiosHeaders(true),
    };

    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({
        type: SET_POPUP_DATA,
        payload: {
          data: response.data,
        }
      });
    }
    yield put({ type: SET_POPUP_LOADER, payload: false });
  } catch (error) {
    yield put({ type: SET_POPUP_LOADER, payload: false });
    console.error("Error fetching popup data:", error);
    // Still show popup with error message
    yield put({
      type: SET_POPUP_DATA,
      payload: {
        data: null,
      }
    });
  }
}

function* openDetailsPopup(action) {
  try {
    yield put({ type: SET_POPUP_LOADER, payload: true });

    // Open the popup immediately
    yield put({
      type: SET_POPUP_OPEN,
      payload: {
        open: true,
        popupDetails: action.payload,
      }
    });
  } catch (error) {
    yield put({ type: SET_POPUP_LOADER, payload: false });
    console.error("Error fetching popup data:", error);

    // Still show popup with error message
    yield put({
      type: SET_POPUP_DATA,
      payload: {
        data: null,
      }
    });
  }
}

function* DataGuardPopupSaga() {
  yield takeEvery(FETCH_POPUP_DATA, fetchPopupData);
  yield takeEvery(OPEN_DETAILS_POPUP, openDetailsPopup);
}

export default DataGuardPopupSaga;